import { useSelector } from 'react-redux';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { FetchClubV2MembershipAPI } from 'Services';
import { IAPI_ACTION, IDispatcherType, INITIAL_STATE } from 'types';
import Toasty from 'components/atoms/Toasty';

export const setAPIError = (state: ReturnType<typeof INITIAL_STATE>, action: IAPI_ACTION): void => {
	state.loading = false;
	state.error = action.error.message || 'Something went wrong';
	Toasty.error(state.error);
};

export const clubMemberInfo = createAsyncThunk('post/clubMemberInfo', FetchClubV2MembershipAPI);

export const ClubMemberInfoSlice = createSlice({
	name: 'clubMemberInfo',
	initialState: INITIAL_STATE(),
	reducers: {
		CLEAR_ERROR: (state) => {
			state.error = '';
		},
		RESET: (state) => Object.assign(state, INITIAL_STATE()),
	},
	extraReducers: {
		[clubMemberInfo.pending.toString()]: (state: ReturnType<typeof INITIAL_STATE>) => {
			state.data = {};
			state.error = '';
			state.loading = true;
			state.isFetched = false;
		},
		[clubMemberInfo.rejected.toString()]: setAPIError,
		[clubMemberInfo.fulfilled.toString()]: (state: ReturnType<typeof INITIAL_STATE>, action: IAPI_ACTION<any>) => {
			const { payload } = action;

			state.loading = false;
			state.isFetched = true;
			state.error = '';
			state.data = {
				isBpClubAlreadyActive: !!payload?.eligibile,
				mdr_benefit: !!payload?.mdr_benefit,
				...payload,
			};
		},
	},
});

interface IStates {
	[ClubMemberInfoSlice.name]: ReturnType<typeof ClubMemberInfoSlice.reducer>;
}

export const clubMemberInfoSelector = (state: IStates): any => {
	return state[ClubMemberInfoSlice.name] || {};
};

export const useClubMemberInfo = (): any => useSelector(clubMemberInfoSelector);

export const checkClubMemberInfo =
	(params: any) =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(clubMemberInfo(params));
		return;
	};

export const resetClubMemberInfo =
	() =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(ClubMemberInfoSlice.actions.RESET());
		return;
	};
